<template>
  <page-layout title="실적 업로드">
    <template v-slot:search>
      <loan-performance-upload-search-bar
        @search="getSearch"
      />
    </template>
    <template v-slot:table>
      <loan-performance-upload-table
        :data="data"
        :loading="loading"
        @refresh="refreshData"
      />
    </template>
  </page-layout>
</template>
<script>
import PageLayout from "@/common/layout/PageLayout.vue";
import LoanPerformanceUploadTable from "@/pages/Loan/components/LoanPerformanceUpload/LoanPerformanceUploadTable.vue";
import {axiosInstance} from "@/util/AxiosModule";
import LoanPerformanceUploadSearchBar
  from "@/pages/Loan/components/LoanPerformanceUpload/LoanPerformanceUploadSearchBar.vue";
import DateMixin from "@/mixin/DateMixin";

export default {
  name: "LoanPerformanceUpload",
  components: {LoanPerformanceUploadSearchBar, LoanPerformanceUploadTable, PageLayout},
  mixins: [DateMixin],
  data() {
    return {
      paramsData: {},
      data: [],
      loading: false
    }
  },
  mounted() {
    this.getSearch({
      yyyymm: this.getNowMonth().replaceAll("-", "")
    });
  },
  methods: {
    async getSearch(params) {
      this.paramsData = params;
      this.loading = true;
      try {
        const { data } = await axiosInstance.get("/admin/performance/files", { params });
        if (data.length < 1) {
          this.data = [];
        } else {
          this.data = data;
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
      this.loading = false;
    },
    refreshData() {
      this.getSearch(this.paramsData);
    }
  }
}
</script>